export default angular.module('syFilter', [])
    /**
     * @ngdoc service
     * @name filter.service:FilterService
     * @description
     * Creates and can be used to manage the scope of a filter that can
     * be reusable throughout the application.
     */
    // @ngInject
    .service('FilterService', function ($timeout) {
        // Return a filter from provided validation
        // @param id {string} Unique reference for this filter
        // @param group {string} Grouping reference for this filter
        // @param isActive {boolean} Default state for filter, false by default
        this.registerFilter = function (id, group, isActive, name) {
            return {
                id: id,
                isActive: isActive || false,
                group: group || null,
                name: name
            };
        };
        // Toggle the provided filter's isActive
        // @param filter {object} Filter to alter the state of
        // @param override {boolean} If provided will override the standard toggle value
        this.toggleFilter = function (filter, override) {
            $timeout(function () {
                if (typeof override === 'boolean') {
                    return (filter.isActive = override);
                }
                filter.isActive = !filter.isActive;
            });
        };
        // Return true when provided filter is currently active
        // @param filter {string} The filter to toggle
        this.isFilterActive = function (filter) {
            return !!filter && filter.isActive;
        };
    })
    /**
     * @ngdoc controller
     * @name filter.controller:filters
     * @description
     * The scope of a filter, to enable control over its state
     */
    // @ngInject
    .controller('FilterController', function ($scope, FilterService) {
        var controller = this;
        var filters = [];
        var groups = [];
        // Bind service functions to controller level
        this.toggleFilter = FilterService.toggleFilter;
        this.isFilterActive = FilterService.isFilterActive;
        // Register and store reference to the provided filter
        // @param id {string} Unique reference for this filter
        // @param group {string} Grouping reference for this filter
        // @param isActive {boolean} Default state for filter, false by default
        this.registerFilter = function (id, group, isActive, name) {
            var filter = FilterService.registerFilter(id, group, isActive, name);
            filters.push(filter);
            if (groups.indexOf(group) === -1) {
                groups.push(group);
            }
            return filter;
        };
        // Return all registered filters. If a group is provided
        // it will only return the filters within that group
        // @param group {string} The filter group reference
        this.getFilters = function (group) {
            if (!group) {
                return filters;
            }
            return filters.filter(function (filter) {
                return filter.group === group;
            });
        };
        // Return all active filters within the provided group
        // @param group {string} The filter group reference
        this.getActiveFilters = function (group) {
            return controller.getFilters(group).filter(function (filter) {
                return filter.isActive === true;
            });
        };
        // Return true if the provided group has has at least one
        // active filter
        // @param group {string} The filter group reference
        this.hasActiveFilter = function (group) {
            return controller.getActiveFilters(group).length > 0;
        };
        // Toggle all registered filters to their opposite state
        // or the provided override value (e.g. deselect all)
        // @param override {boolean} An overriding state to use
        this.toggleAllFilters = function (group, override) {
            return controller.getFilters(group).forEach(function (filter) {
                FilterService.toggleFilter(filter, override);
            });
        };
        // Return true if all registered filters are active
        // @param group {string} The filter group reference
        this.areAllActive = function (group) {
            if (filters.length < 1) {
                return false;
            }
            return filters.reduce(function (prev, current) {
                if (prev === false) {
                    return false;
                }
                if (group && current.group !== group) {
                    return true;
                }
                return current.isActive;
            }, true);
        };
        // Returns true if at least 1 filter from each group is active
        this.validFilters = function () {
            return groups.reduce(function (prev, current) {
                return prev === false ? false : controller.hasActiveFilter(current);
            }, true);
        };
        // If there is an active navigation, add
        // a body class to allow fixed scrolling styles
        $scope.$watch('isActive', function (isActive) {
            angular.element(document.body)
                .toggleClass('filters--active', isActive);
        });
    })
    /**
     * @ngdoc directive
     * @name filter.directive:filters
     * @restrict A
     * @description
     * Assigns a new scope and controller for each filters' instance
     */
    // @ngInject
    .directive('syFilters', function ($q, AnalyticsService) {
        return {
            scope: true,
            controller: 'FilterController',
            controllerAs: 'filterController',
            restrict: 'A',
            link: function ($scope, $element, attrs, controller) {
                var $filterForm = $element.find('form');
                $filterForm.on('submit', function (e) {
                    e.preventDefault();
                    var trackingPromises = [];
                    controller.getActiveFilters().forEach(function (filter) {
                        var deferred = $q.defer();
                        var pageView = [window.location.pathname, 'filter', filter.name].join('/');
                        trackingPromises.push(deferred.promise);
                        AnalyticsService.trackPage(pageView, deferred.resolve);
                    });
                    // When all tracking responses are back submit form
                    $q.all(trackingPromises).then(function () {
                        $filterForm[0].submit();
                    });
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name filter.directive:filterToggleGroup
     * @restrict A
     * @description
     * Toggles all filters within the current filters' scope
     */
    // @ngInject
    .directive('syFilterToggleGroup', function () {
        return {
            restrict: 'A',
            require: '^syFilters',
            link: function ($scope, $element, attrs, controller) {
                var group = attrs.syFilterToggleGroup || null;
                $element.on('click touchend', function (e) {
                    e.preventDefault();
                    var override = controller.areAllActive(group) ? false : true;
                    controller.toggleAllFilters(group, override);
                });
                $scope.$watch(function () {
                    return controller.areAllActive(group);
                }, function (areActive) {
                    var actionLabel = areActive ? 'Deselect ' : 'Select ';
                    $element.html([actionLabel, 'all <span>', group, '</span>'].join(''));
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name filter.directive:filter
     * @restrict A
     * @description
     * Watches and sets the state of an input based on it's filter status
     */
    // @ngInject
    .directive('syFilter', function () {
        return {
            restrict: 'A',
            require: '^syFilters',
            scope: true,
            link: function ($scope, $element, attrs, controller) {
                var filterName = $element.children().text();
                // If the filter name exists we want to slice off any
                // reference to the count of results that match the filter
                // which always are within (brackets) e.g. FAQs (21)
                if (filterName) {
                    filterName = filterName.split('(').slice(0, 1).join('').trim();
                }
                $scope.filter = controller.registerFilter(attrs.syFilter || attrs.id, attrs.syFilterGroup, null, filterName);
            }
        };
    })
    /**
     * @ngdoc directive
     * @name filter.directive:filter
     * @restrict A
     * @description
     * Watches and sets the state of an input based on it's filter status
     */
    // @ngInject
    .directive('syFilterInput', function ($timeout) {
        return {
            restrict: 'A',
            require: '^syFilters',
            link: function ($scope, $element, attrs, controller) {
                var defaultValue = $element[0].checked;
                // This timeout insures that full initialization of the
                // controller is completed and then we set the filter value
                // off the defaultValue which we pick up _before_ the digest
                // can change it.
                $timeout(function () {
                    controller.toggleFilter($scope.filter, defaultValue);
                });
                $element.on('change propertychange', function () {
                    controller.toggleFilter($scope.filter, $element[0].checked);
                });
                $scope.$watch(function () {
                    return controller.isFilterActive($scope.filter);
                }, function (isActive) {
                    $element[0].checked = isActive;
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name filter.directive:filterOption
     * @restrict A
     * @description
     * Controls if a filter option can be selected or unchecked
     * depending on the parent filter
     */
    // @ngInject
    .directive('syFilterOption', function ($timeout) {
        return {
            restrict: 'A',
            require: '^syFilters',
            link: function ($scope, $element, attrs, controller) {
                var defaultValue = $element[0].checked;
                // This timeout insures that full initialization of the
                // controller is completed and then we set the filter value
                // off the defaultValue which we pick up _before_ the digest
                // can change it.
                $timeout(function () {
                    // Only allow this to be set if the parent is checked
                    if (controller.isFilterActive($scope.filter)) {
                        $element[0].checked = defaultValue;
                    }
                }, 250);
                $scope.$watch(function () {
                    return controller.isFilterActive($scope.filter);
                }, function (isActive) {
                    $element[0].disabled = !isActive;
                    $element[0].checked = isActive ? defaultValue : false;
                });
            }
        };
    });
